import React from 'react'
import {Row, Col, Empty, Spin, Form, Select} from 'antd'
import {Column, Line, Bar} from '@ant-design/charts'
import {ExclamationCircleFilled, CheckCircleFilled, CloseCircleFilled} from '@ant-design/icons'
import {inject, observer} from 'mobx-react'
import {toJS} from 'mobx'
import FormModal from './FormModal'
import moment from 'moment'
import alertMessage from '../../utils/alertMessage'
import $ from 'jquery'
import {withTranslation} from 'react-i18next'
const storage = window.localStorage

@inject('homeStore')
@observer
class Home extends React.Component {
  state = {
    isFetchingAPI: true,
    isFetchingMessage: true,
    isFetchingDistribution: true,
    apiSelect: ''
  }
  formRef = React.createRef()

  componentDidMount() {
    const {homeStore} = this.props
    storage.setItem('selectedItem','home')
    homeStore.onChangeData()
    //get record
    homeStore.onGetCountAction().then(response => {
      if (response?.data?.code === 0) {
        //get customer
        homeStore.onGetCustomerAction({'dictionaryType': 'API_ROUTER_CUSTOMER'}, '1').then(respon => {
          if (respon?.data?.code === 0) {
            this.setState({
              isFetchingAPI: false
            })
            //get Message Statistics shortName and data
            homeStore.onGetShortName({customers: Array.from(homeStore.messageCustomer)}).then(res => {
              if (res?.data?.code === 0) {
                //get Message Distribution shortName and data
                let shortNamesArr = []
                shortNamesArr = homeStore.onCompareMessageDistructionShortName(homeStore.messageRecord.messageShortName, res.data.data)
                homeStore.onChangeMessageShortName(shortNamesArr)
                const newShortNames = []
                for (let i = 0; i < shortNamesArr.length; i++) {
                  homeStore.shortNames.filter(item => item.shortName === shortNamesArr[i]).map(it => {
                    return newShortNames.push({
                      customer: it.customer,
                      shortName: it.shortName
                    })
                  })
                }
                if (newShortNames.length > 0) {
                  homeStore.onSearchMessageAction({
                    startTime: moment().format('YYYY-MM-DD') + ' 00:00:00',
                    endTime: moment().format('YYYY-MM-DD') + ' 23:59:59',
                    messageDistributionCustomerVoList: homeStore.onChangeCustomer(newShortNames),
                  }).then(() => {
                    this.setState({
                      isFetchingMessage: false
                    })
                    homeStore.onSearchMessageDistributionAction({
                      startTime: moment().format('YYYY-MM-DD') + ' 00:00:00',
                      endTime: moment().format('YYYY-MM-DD') + ' 23:59:59',
                      messageDistributionCustomerVoList: homeStore.onChangeCustomer(newShortNames),
                    }).then(() => {
                      this.setState({
                        isFetchingDistribution: false
                      })
                    })
                  })
                } else {
                  this.setState({
                    isFetchingMessage: false,
                    isFetchingDistribution: false
                  })
                }
              } else {
                alertMessage.error(res?.data?.messageEn).then()
              }
            })
            //Connect Statistics
            const customerValue = response?.data?.data?.messageCustomer ? JSON.parse(response?.data?.data?.messageCustomer)[0] : null
            const customerName = respon.data.data.find(item => item?.id === customerValue)?.customer
            this.formRef.current.setFieldsValue({
              customer: customerName
            })
            this.setState({
              apiSelect: customerName
            })
          } else {
            alertMessage.error(respon?.data?.messageEn).then()
          }
        })
      } else {
        // console.log(response)
        // alertMessage.error(response?.data?.data?.messageEn)
      }
    })
    //business
    homeStore.onGetBusinessAction({
      startTime: moment().format('YYYY-MM-DD') + ' 00:00:00',
      endTime: moment().format('YYYY-MM-DD') + ' 23:59:59',
    }).then()
  }

  handleChangeApi = (value) => {
    console.log('value', value)
    this.setState({
      apiSelect: value
    })
  }

  render() {
    const themeStyle = JSON.parse(storage.getItem('themeStyle'))
    const {homeStore, t} = this.props
    const {
      isFetchingBusiness,
      isFetchingAPI,
      isFetchingMessage,
      isFetchingDistribution,
      businessList,
      apiList,
      apiSelectList,
      messagesList,
      messagesDistributionList
    } = homeStore

    const apiHeight = ($('.ant-layout-content').height() - 120) / 2
    $('.position_rel').height(apiHeight - 32)
    const brandColor = themeStyle?.statusColor && themeStyle?.statusColor?.split(',') ? themeStyle?.statusColor?.split(',') || [] : ['#97cf7c', '#ef6e6e', '#7ac3e0', '#facb61']
    const config = {
      data: toJS(messagesList),
      height: apiHeight - 100,
      xField: 'customer',
      yField: 'value',
      seriesField: 'type',
      isGroup: 'true',
      maxColumnWidth: '50',
      // scrollbar: {
      //   type: 'horizontal',
      // },
      color: function color(_ref) {
        const type = _ref.type
        if (type === 'SUCCESSFUL') {
          return brandColor[0]
        } else if (type === 'ERROR') {
          return brandColor[1]
        } else if (type === 'RUNNING') {
          return brandColor[2]
        } else {
          return brandColor[3]
        }
      },
      columnStyle: {
        radius: [20, 20, 0, 0],
      },
      animation: {
        appear: {
          animation: 'path-in',
          duration: 5000,
        },
      },
      xAxis: {
        label: {
          style: {
            textAlign: 'center'
          },
          position: 'center',
          autoRotate: true,
        },
      },
    }
    const configBusiness = {
      data: toJS(businessList),
      height: apiHeight - 120,
      isGroup: true,
      xField: 'value',
      yField: 'label',
      seriesField: 'type',
      dodgePadding: 5,
      // intervalPadding: 50,
      maxBarWidth: '8',
      legend: {
        position: 'top-left'
      },
      scrollbar: {
        type: 'vertical',
      },
      color: [brandColor[0], brandColor[2]],
      label: {
        // 可手动配置 label 数据标签位置
        position: 'middle', // 'left', 'middle', 'right'
        // 可配置附加的布局方法
        layout: [
          // 柱形图数据标签位置自动调整
          {type: 'interval-adjust-position'},
          // 数据标签防遮挡
          {type: 'interval-hide-overlap'},
          // 数据标签文颜色自动调整
          {type: 'adjust-color'},
        ],
      },
    }
    const lineConfig = {
      data: toJS(messagesDistributionList),
      height: apiHeight - 110,
      xField: 'daily',
      yField: 'count',
      seriesField: 'shortName',
      smooth: true,
      color: brandColor,
      animation: {
        appear: {
          animation: 'path-in',
          duration: 5000,
        },
      },
      update: {
        legend: false,
      }
    }
    return (
      <>
        <div className="searchMain">
          <FormModal/>
        </div>
        <Row className="index_main">
          <Col span={18} style={{paddingRight: 15}}>
            <div className="position_rel">
              <div className="index_title">{t(`home.messageStatistics`)}</div>
              <Spin spinning={this.state.isFetchingMessage || isFetchingMessage}>
                {messagesList.length > 0 ? <Column {...config} style={{marginTop: 10, paddingBottom: 20}}/> :
                  <Empty style={{height: '100%', lineHeight: '100%'}} image={Empty.PRESENTED_IMAGE_SIMPLE}/>}
              </Spin>
            </div>
          </Col>
          <Col span={6}>
            <div className="position_rel">
              <div className="index_title">{t(`home.businessStatistics`)}</div>
              <Spin spinning={isFetchingBusiness}>
                {businessList.length > 0 ?
                  <Bar {...configBusiness} style={{marginTop: 10, paddingBottom: 20}}/> :
                  <Empty style={{height: '100%', lineHeight: '100%'}} image={Empty.PRESENTED_IMAGE_SIMPLE}/>
                }
              </Spin>
            </div>
          </Col>
          <Col span={18} style={{paddingRight: 15}}>
            <div className="position_rel">
              <div className="index_title">{t(`home.messageDistribution`)}</div>
              <Spin spinning={this.state.isFetchingDistribution || isFetchingDistribution}>
                {messagesDistributionList.length > 0 ? <Line {...lineConfig} style={{marginTop: 10, paddingBottom: 20}}/> :
                  <Empty style={{height: '100%', lineHeight: '100%'}} image={Empty.PRESENTED_IMAGE_SIMPLE}/>}
              </Spin>
            </div>
          </Col>
          <Col span={6}>
            <div className="position_rel">
              <div className="index_title">
                <Row>
                  <Col xs={24} sm={24} md={12} lg={12} xl={16} xxl={16} span={16}>{t(`home.connectStatistics`)}</Col>
                  <Col xs={24} sm={24} md={12} lg={12} xl={8} xxl={8} span={8} style={{marginTop: 8}}>
                    <Form ref={this.formRef}>
                      <Form.Item name="customer">
                        <Select
                          style={{width: '100%'}}
                          defaultValue={apiSelectList[0]?.value}
                          onChange={this.handleChangeApi}
                          options={toJS(apiSelectList)}
                        />
                      </Form.Item>
                    </Form>
                  </Col>
                </Row>
              </div>
              <div className="_tooltips">
                <p><span style={{background: brandColor[0]}}/>{t(`home.normal`)}</p>
                <p><span style={{background: brandColor[3]}}/>{t(`home.abnormal`)}</p>
                <p><span style={{background: brandColor[1]}}/>{t(`home.freeze`)}</p>
              </div>
              <Spin spinning={this.state.isFetchingAPI || isFetchingAPI}>
                <div className="APIStatistics">
                  {apiList.length > 0 ?
                    <div className="_body" style={{height: apiHeight - 140}}>
                      {apiList.find(items => items?.customer === this.state.apiSelect)?.statisticsConfigInfoVo?.map((item, index) => (
                        <p key={index} title={item.shortName}> {item.status === 'Freeze' ?
                          <ExclamationCircleFilled style={{color: brandColor[3]}}/> : item.status === 'Normal' ?
                            <CheckCircleFilled style={{color: brandColor[0]}}/> :
                            <CloseCircleFilled style={{color: brandColor[1]}}/>} {item.shortName}</p>
                      ))}
                    </div>
                    : <Empty style={{height: 236, lineHeight: '236px'}} image={Empty.PRESENTED_IMAGE_SIMPLE}/>}
                </div>
              </Spin>
            </div>
          </Col>
        </Row>
      </>
    )
  }
}

export default withTranslation()(Home)
